// Store codes must be added explicitly before a centre can open Billing.
export const BILLING_ALLOWED_STORE_CODES = [
  "BST1319",
  "KA/BLR/01/24",
  "UP/RBL/10/22",
  "UP/KSB/02/23",
  "UP/KSN/05/25",
  "JH/KDR/01/26",
  "UP/SKN/10/22",
];

export const isStoreCodeAllowedForBilling = (storeCode = "") => {
  const normalizedStoreCode = storeCode.trim().toUpperCase();

  return BILLING_ALLOWED_STORE_CODES.some(
    (allowedStoreCode) =>
      allowedStoreCode.trim().toUpperCase() === normalizedStoreCode,
  );
};

export const getBillingUrl = (apiUrl = "") => {
  try {
    const hostname = new URL(apiUrl).hostname.toLowerCase();
    const isDomainOrSubdomain = (domain) =>
      hostname === domain || hostname.endsWith(`.${domain}`);

    if (isDomainOrSubdomain("chikitsamitra.co.in")) {
      return "https://beta-mso.chikitsamitra.in";
    }

    if (isDomainOrSubdomain("chikitsamitra.com")) {
      return "https://beta-mso.chikitsamitra.com";
    }
  } catch (error) {
    return null;
  }

  return null;
};
